module.exports = __webpack_public_path__ + "static/media/pdfTerminos.0b80ff88.pdf";